<template>
	<modal :exibir="value" :titulo="tituloModal" :max-width="1250" class="modal-confirmacao" @close="fecharModal">
		<template #body>
			<v-container>
				<div class="header-content">
					<div>
						<span><b class="primary--text">Tipo:</b></span>
						<br />
						<span class="text--black">{{ pedidoDetalhe.tipo }}</span>
					</div>
					<div class="description-limitation">
						<span><b class="primary--text">Item:</b></span>
						<br />
						<texto-tooltip :texto="pedidoDetalhe.item" :tamanho-maximo="textoTamanhoMaximo"></texto-tooltip>
					</div>
				</div>

				<v-row>
					<v-col>
						<az-form class="pa-0">
							<v-data-table
								:items="items"
								:headers="colunas"
								item-key="id"
								hide-default-footer
								@paginar="tratarEventoPaginar"
								no-data-text="Nenhum pedido por aqui"
								class="arp-listview"
								:items-per-page="paginacaoInterna.rowsPerPage"
								:page="paginacaoInterna.page"
							>
								<template #[`item.numeroPedido`]="{ item }">
									<a @click="redirecionar(item.idPedido)">{{ item.numeroPedido }}</a>
								</template>
								<template #[`item.situacaoPedido`]="{ item }">
									{{ item.situacaoPedido }}
								</template>
								<template #[`item.dataSituacao`]="{ item }">
									<div>
										<template v-if="item.dataSituacao">
											{{ item.dataSituacao | formatDataFilter }}
										</template>
										<template v-else> -- </template>
									</div>
								</template>
								<template #[`item.quantidadeSolicitada`]="{ item }">
									{{ item.quantidadeSolicitada | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
								</template>
								<template #[`item.nomeResponsavel`]="{ item }">
									{{ item.nomeResponsavel }}
								</template>
								<template #[`item.numeroProcesso`]="{ item }">
									{{ item.numeroProcesso }}
								</template>
								<template #[`item.contratosVinculados`]="{ item }">
									<span class="description-limitation-template">
										<texto-tooltip
											:texto="item.contratosVinculados ? item.contratosVinculados : '--'"
											:tamanho-maximo="40"
										></texto-tooltip>
									</span>
								</template>
								<template #no-data></template>
								<paginacao-tabela
									v-if="totalItens > 0"
									:page.sync="paginacaoInterna.page"
									:rows-per-page.sync="paginacaoInterna.rowsPerPage"
									:totalPaginas="totalPaginas"
									:totalItens="totalItens"
									:show-rows-per-page="false"
								></paginacao-tabela>
							</v-data-table>
						</az-form>
						<paginacao-tabela
							v-if="Number(totalElements) > 0"
							:page.sync="paginacaoInterna.page"
							:rows-per-page.sync="paginacaoInterna.rowsPerPage"
							:totalPaginas="Number(totalPages)"
							:totalItens="Number(totalElements)"
						></paginacao-tabela>
					</v-col>
				</v-row>
			</v-container>
		</template>
	</modal>
</template>
<script>
import { actionTypes } from '@/core/constants'
import Modal from '@/views/components/Modal.vue'
import tabela from '@/views/mixins/tabela'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import { TabelaColunaUtils } from '@/core/utils'
import TextoTooltip from '@/views/components/TextoTooltip.vue'

export default {
	name: 'modal-incluir-dotacao',
	components: { TextoTooltip, PaginacaoTabela, Modal },
	mixins: [tabela],
	props: {
		idItem: {
			type: Number,
			default: 0,
		},
		pedidoDetalhe: {
			type: Object,
			default: () => {},
		},
		tituloModal: {
			type: String,
			default: '',
		},
		value: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['input', 'buscar-dotacoes', 'paginar'],
	data() {
		return {
			paginacaoInterna: this.paginacao,
			totalPages: this.totalPaginas,
			totalElements: this.totalItens,
			items: [],
			textoTamanhoMaximo: 100,
			colunas: [
				new TabelaColunaUtils('Pedido', 'numeroPedido', '10%'),
				new TabelaColunaUtils('Situação', 'situacaoPedido', '15%'),
				new TabelaColunaUtils('Data', 'dataSituacao', '10%'),
				new TabelaColunaUtils('Solicitado Pedido', 'quantidadeSolicitada', '15%'),
				new TabelaColunaUtils('Responsável', 'nomeResponsavel', '15%'),
				new TabelaColunaUtils('Processo', 'numeroProcesso', '15%'),
				new TabelaColunaUtils('Contratos Vinculados', 'contratosVinculados', '20%'),
			],
		}
	},
	computed: {
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
	},
	watch: {
		paginacaoInterna: {
			handler() {
				this.loadData()
			},
			deep: true,
		},
	},
	async created() {
		await this.loadData()
	},
	methods: {
		async loadData() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ATA.ACOMPANHAMENTO.BUSCAR_LISTAGEM_DETALHES_SALDO_POR_ORGAO,
				{
					filtros: { idOrgao: this.idItem },
					paginacao: this.paginacaoInterna,
					idAta: this.$route.params.id,
					idItem: this.pedidoDetalhe.idItem,
				},
			)
			this.items = itens
			this.totalPages = totalPages
			this.totalElements = totalElements
		},
		async tratarEventoPaginar(paginacao) {
			this.$emit('paginar', paginacao)
		},
		async redirecionar(idPedido) {
			await this.$router.push({
				name: 'PedidoAcessarItensView',
				params: { id: idPedido },
			})
		},
		fecharModal() {
			this.$emit('input', false)
		},
	},
}
</script>
<style lang="stylus" scoped>
.az-template-default
	.container
		background white
.header-content {
	display: grid;
	grid-template-columns: 120px auto;
	padding: 12px 0 12px 8px;
}
.description-limitation {
	text-overflow: ellipsis;
	overflow: hidden;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	display: block;
	display: -webkit-box;
}
.description-limitation-template {
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: block;
  display: -webkit-box;
  max-height: 48px;
}

.botao-voltar{
	color: #c2c2c2 !important
}
</style>
